// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewSchemesPage {
  padding-left: 281px;
  background: #EFF0F4;
  width: 100%;
  height: 100vh;
}
.NewSchemesPage .titleBlock {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  background: #fff;
  padding-top: 43px;
  padding-left: 40px;
  padding-bottom: 27px;
}
.NewSchemesPage .titleBlock span {
  font-family: "Montserrat Regular";
  font-weight: 500;
  font-size: 24px;
}
.NewSchemesPage .schemesGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px 0;
}
.NewSchemesPage .schemesGrid > div {
  width: 160px;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  background-color: #fff;
  transition: transform 0.2s ease;
}
.NewSchemesPage .schemesGrid > div:hover {
  transform: translateY(-4px);
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/NewSchemesPage/NewSchemesPage.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AACR;AACQ;EACI,iCAAA;EACA,gBAAA;EACA,eAAA;AACZ;AAGI;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;AADR;AAII;EACI,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,sBAAA;EACA,+BAAA;AAFR;AAIQ;EACI,2BAAA;AAFZ","sourcesContent":[".NewSchemesPage {\n    padding-left: 281px;\n    background: #EFF0F4;\n    width: 100%;\n    height: 100vh;\n\n    .titleBlock {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: left;\n        background: #fff;\n        padding-top: 43px;\n        padding-left: 40px;\n        padding-bottom: 27px;\n\n        span {\n            font-family: \"Montserrat Regular\";\n            font-weight: 500;\n            font-size: 24px;\n        }\n    }\n\n    .schemesGrid {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n        padding: 16px 0;\n    }\n\n    .schemesGrid>div {\n        width: 160px;\n        border: 1px solid #eee;\n        border-radius: 8px;\n        padding: 8px;\n        box-shadow: 0 2px 6px rgb(0 0 0 / 0.1);\n        position: relative;\n        background-color: #fff;\n        transition: transform 0.2s ease;\n\n        &:hover {\n            transform: translateY(-4px);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NewSchemesPage": `NewSchemesPage`,
	"titleBlock": `titleBlock`,
	"schemesGrid": `schemesGrid`
};
export default ___CSS_LOADER_EXPORT___;
